var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.198242 10.6426C0.198242 5.12358 4.67824 0.642578 10.1982 0.642578C15.7282 0.642578 20.1982 5.12358 20.1982 10.6426C20.1982 16.1636 15.7282 20.6426 10.1982 20.6426C4.67824 20.6426 0.198242 16.1636 0.198242 10.6426ZM9.31824 6.85258C9.31824 6.37358 9.71824 5.97258 10.1982 5.97258C10.6782 5.97258 11.0682 6.37358 11.0682 6.85258V11.2726C11.0682 11.7536 10.6782 12.1426 10.1982 12.1426C9.71824 12.1426 9.31824 11.7536 9.31824 11.2726V6.85258ZM10.2082 15.3236C9.71824 15.3236 9.32824 14.9236 9.32824 14.4436C9.32824 13.9636 9.71824 13.5736 10.1982 13.5736C10.6882 13.5736 11.0782 13.9636 11.0782 14.4436C11.0782 14.9236 10.6882 15.3236 10.2082 15.3236Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.3d01d328ff6c745b1832cf4e80914475.svg";
export { ForwardRef as ReactComponent };